"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = buildSubscriptionPayload;

var _buildOrganisationInfoPayload = _interopRequireDefault(require("../../../utils/buildOrganisationInfoPayload"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function getSubscriptionFromOrganisation(organisation) {
  var accountManager = organisation.accountManager,
      bdm = organisation.bdm,
      subPackage = organisation.package,
      editingTeamId = organisation.editingTeamId,
      equipment = organisation.equipment,
      billingEntityCode = organisation.billingEntityCode;
  return {
    accountManagerId: accountManager ? accountManager.userId : null,
    bdmId: bdm ? bdm.userId : null,
    editingTeamId: editingTeamId,
    billingEntityCode: billingEntityCode,
    equipment: equipment,
    package: subPackage
  };
}

function getSubscriptionFromSubState(subState) {
  var editingTeam = subState.editingTeam,
      subPackage = subState.subPackage;
  return getSubscriptionFromOrganisation(_objectSpread({}, subState, {
    editingTeamId: editingTeam ? editingTeam.teamId : null,
    package: subPackage ? _objectSpread({}, subPackage, {
      displayName: void 0,
      name: void 0
    }) : null
  }));
}

function buildSubscriptionPayload(originalSubscription, subscriptionState) {
  return (0, _buildOrganisationInfoPayload.default)(getSubscriptionFromOrganisation(originalSubscription), getSubscriptionFromSubState(subscriptionState));
}